var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{staticClass:"mb-0",attrs:{"color":"primary","dark":""}},[_vm._v(" Good Morning! Start your day with some alerts. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }